import React from "react";
import ReusableDataTable from "../../hooks/ReusableDataTable";
import { Button, Checkbox, Label, Modal, TextInput,Select,Badge } from "flowbite-react";
import { Link } from "react-router-dom";
import { FaEye } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import '../../style/model.css';
import { FaPen } from "react-icons/fa";
import { MdDeleteForever } from "react-icons/md";
import { HiOutlineExclamationCircle } from "react-icons/hi";
import useInputValidation from "../../hooks/useInputValidation";
import Swal from "sweetalert2";
import "sweetalert2/dist/sweetalert2.css";
import axios from "axios";
import { useSidebar } from "../../context/SidebarOpenContext";
function RawMaterial() {
    const navigate = useNavigate();
    const [AddModal, setAddModal] = useState(false);
    const [EditModal, setEditModal] = useState(false);
    const [DeleteModal, setDeleteModal] = useState(false);
    const [Input, setInput] = useState({});
    const [RawMaterial,setRawMaterial]=useState({});
    const { errors, handleChange, resetErrors } = useInputValidation();
    const { isSidebarOpen, toggleSidebar } = useSidebar();
    useEffect(() => {
        fetchRawMaterial();
    }, []);


    const onChangeValue = (e) => {
        handleChange(e);
        setInput({ ...Input, [e.target.name]: e.target.value });
    }

    const fetchRawMaterial = async () => {
        try {
            const response = await axios.get("master/raw_material_stocks");
            const RawMaterialData = response.data;
            setRawMaterial(RawMaterialData);
        } catch (error) {
            console.error("Error fetching RawMaterial data:", error);
        }
    };

    const addRawMaterial = async (event) => {
        event.preventDefault();
        try {
            axios
                .post(`master/raw_material_stocks`, {
                    raw_material_name: Input.rname,
                    stock_count:Input.stock,
                    unit:Input.unit,
                    status:Input.status,
                })
                .then((res) => {
                    if (res.data.success === 1) {
                        Swal.fire({
                            icon: "success",
                            text: "Trims Created",
                            type: "success",
                            timer: 2000,
                            showConfirmButton: false,
                        });
                        setAddModal(false);
                        fetchRawMaterial();


                    } else if (res.data.success === 2) {
                        Swal.fire({
                            icon: "error",
                            text: "RawMaterial already exists...",
                            type: "error",
                            timer: 2000,
                            showConfirmButton: false,
                        });
                    } else {
                        Swal.fire({
                            icon: "error",
                            text: "Server Problem. Please Try Again...",
                            type: "error",
                            timer: 2000,
                            showConfirmButton: false,
                        });
                    }
                    return;
                });
        } catch (error) {
            throw error;
        }

    };

    const UpdateRawMaterial = async (event) => {
        event.preventDefault();

        try {
            axios
                .put(`master/raw_material_stocks/${Input.id}`, {
                    raw_material_name: Input.rname,
                    stock_count:Input.stock,
                    unit:Input.unit,
                    status:Input.status,
                    raw_material_stock_id: Input.id
                })
                .then((res) => {
                    if (res.data.success === 1) {
                        Swal.fire({
                            icon: "success",
                            text: "Trims Details Updated",
                            type: "success",
                            timer: 2000,
                            showConfirmButton: false,
                        });
                        setEditModal(false);
                        fetchRawMaterial();
                    } else {
                        Swal.fire({
                            icon: "error",
                            text: "Server Problem. Please Try Again...",
                            type: "error",
                            timer: 2000,
                            showConfirmButton: false,
                        });
                    }
                    return;
                });
        } catch (error) {
            throw error;
        }

    };

    const deletRawMaterial = async () => {
        try {
            axios.delete(`master/raw_material_stocks/${Input.id}`).then((res) => {
                if (res.data.success === 1) {
                    Swal.fire({
                        icon: "success",
                        text: "Trims deleted",
                        type: "success",
                        timer: 2000,
                        showConfirmButton: false,
                    });
                    fetchRawMaterial();
                    setDeleteModal(false);
                } else {
                    Swal.fire({
                        icon: "error",
                        text: "Server Problem. Please Try Again...",
                        type: "error",
                        timer: 2000,
                        showConfirmButton: false,
                    });
                }
                return;
            });
        } catch (error) {
            throw error;
        }
    };

    
     const data = Array.isArray(RawMaterial)
            ? RawMaterial.map((RM) => ({
                id: RM.raw_material_id,
                rname: RM.raw_material_name,
                stock: RM.stock_count,
                unit:RM.unit,
                status:RM.status,
                option: (<div style={{ display: "flex" }}>
                    <FaPen className="text-amber-400 text-xl" onClick={() => {
                        setEditModal(true); setInput({
                            id: RM.raw_material_id,
                            rname: RM.raw_material_name,
                            stock: RM.stock_count,
                            unit:RM.unit,
                            status:RM.status,
                        });
                    }} />
                    <MdDeleteForever className="ml-2 text-red-500 text-2xl" onClick={() => { setDeleteModal(true); setInput({ id: RM.raw_material_id }) }} />
                </div>)
            }))
            : [];


    const columns = [
        { name: "S.No", selector: (row, index) => index + 1, sortable: true },
        { name: "Trims Name", selector: (row) => row.rname, sortable: true },
        { name: "Stock", selector: (row) => row.stock, sortable: true },
        { name: "Unit", selector: (row) => row.unit, sortable: true },
        { name: "Status", selector: (row) => row.status,
            cell: row => (
                <Badge color={row.status == "active" ? "success":"failure"}>{row.status}</Badge>
          ),  sortable: true },
        { name: "Option", selector: (row) => row.option },
    ];

    return (
        <div className={` ${ isSidebarOpen  ? "p-4 sm:ml-64 bg-content-bg min-h-screen " : "p-4  bg-content-bg min-h-screen"}  `} >

            <div className="p-4 rounded-lg dark:border-gray-700  mt-14">
                <div className="p-4 rounded-lg shadow bg-white">
                    <Button className="bg-icon-color  text-sidebar-color drop-shadow-md  font-bold" onClick={() => setAddModal(true)} >Add Trims</Button>
                    <ReusableDataTable
                        title="Trims List"
                        columns={columns}
                        data={data}
                    />
                </div>
            </div>

            <Modal show={AddModal} size="md" onClose={() => { setAddModal(false);resetErrors(); }} popup>
                <Modal.Header />
                <Modal.Body>
                    <div className="space-y-6">
                        <h3 className="text-xl font-medium text-gray-900 dark:text-white">Add Trims</h3>
                        <form onSubmit={addRawMaterial}>
                        <div>
                            <div className="mb-2 block">
                                <Label htmlFor="email" value="Trims Name" />
                            </div>
                            <TextInput
                                name="rname"
                                id="rname"
                                placeholder=""
                                type="text"
                                required
                                onChange={onChangeValue}
                                // color={errors.rname && "failure"}
                                // helperText={
                                //     errors.rname && (
                                //         <>
                                //             <span className="font-medium"></span> {errors.rname}
                                //         </>
                                //     )
                                // }
                                // pattern="^[A-Za-z\s]*$"
                            />
                        </div>
                        <div>
                            <div className="pt-2 mb-2 block">
                                <Label htmlFor="stock" value="Stock" color={errors.stock && "failure"} />
                            </div>
                                <TextInput
                                    id="stock"
                                    name="stock"
                                    type="number"
                                    min={1}
                                    step="0.001"
                                    pattern="^\d+(\.\d{1,3})?$"
                                    onChange={onChangeValue}
                                    color={errors.stock && "failure"}
                                    helperText={
                                        errors.stock && (
                                            <>
                                                <span className="font-medium"></span> {errors.stock}
                                            </>
                                        )
                                    }
                                    required />
                        </div>
                        <div>
                            <div className="pt-2 mb-2 block">
                                <Label htmlFor="stock" value="Unit" />
                            </div>
                            <Select id="unit" name="unit"  onChange={onChangeValue} required>
                                <option value="">Select an option</option>
                                <option value="kg">KG</option>
                                <option value="piece">Piece</option>
                                <option value="meter">Meter</option>
                                <option value="gross">Gross</option>
                            </Select>
                        </div>
                        <div>
                            <div className="pt-2 mb-2 block">
                                <Label htmlFor="status" value="Status" />
                            </div>
                            <Select id="status" name="status"  onChange={onChangeValue} required>
                                <option value="">Select an option</option>
                                <option value="active">Active</option>
                                <option value="inactive">Inactive</option>
                            </Select>
                        </div>
                        <div className="pt-2 w-full flex justify-center">
                            <Button className="bg-icon-color  text-sidebar-color drop-shadow-md  font-bold" type="submit">Submit</Button>
                            <Button className="ml-2" color="gray" onClick={() => {setAddModal(false);resetErrors();}}>
                                Cancel
                            </Button>
                        </div>
                        </form>
                    </div>
                </Modal.Body>
            </Modal>

            <Modal show={EditModal} size="md" onClose={() => { setEditModal(false);resetErrors();}} popup>
                <Modal.Header />
                <Modal.Body>
                    <div className="space-y-6">
                        <h3 className="text-xl font-medium text-gray-900 dark:text-white">Update Trims</h3>
                        <form onSubmit={UpdateRawMaterial}>
                        <div>
                            <div className="mb-2 block">
                                <Label htmlFor="email" value="Trims Name" />
                            </div>
                            <TextInput
                                name="rname"
                                id="rname"
                                placeholder=""
                                type="text"
                                required
                                onChange={onChangeValue}
                                // color={errors.rname && "failure"}
                                // helperText={
                                //     errors.rname && (
                                //         <>
                                //             <span className="font-medium"></span> {errors.rname}
                                //         </>
                                //     )
                                // }
                                // pattern="^[A-Za-z\s]*$"
                                value={Input.rname}
                            />
                        </div>
                        <div>
                            <div className="pt-2 mb-2 block">
                                <Label htmlFor="stock" value="Stock" color={errors.stock && "failure"} />
                            </div>
                                <TextInput
                                    id="stock"
                                    name="stock"
                                    type="number"
                                    min={1}
                                    step="0.001"
                                    pattern="^\d+(\.\d{1,3})?$"
                                    onChange={onChangeValue}
                                    color={errors.stock && "failure"}
                                    helperText={
                                        errors.stock && (
                                            <>
                                                <span className="font-medium"></span> {errors.stock}
                                            </>
                                        )
                                    }
                                    required
                                    value={Input.stock} />
                        </div>
                        <div>
                            <div className="pt-2 mb-2 block">
                                <Label htmlFor="stock" value="Unit" />
                            </div>
                            <Select id="unit" name="unit"  onChange={onChangeValue} value={Input.unit}  required>
                                <option value="">Select an option</option>
                                <option value="kg">KG</option>
                                <option value="piece">Piece</option>
                                <option value="meter">Meter</option>
                                <option value="gross">Gross</option>
                            </Select>
                        </div>
                        <div>
                            <div className="pt-2 mb-2 block">
                                <Label htmlFor="status" value="Status" />
                            </div>
                            <Select id="status" name="status" value={Input.status}   onChange={onChangeValue} required>
                                <option value="active">Active</option>
                                <option value="inactive">Inactive</option>
                            </Select>
                        </div>
                        <div className="pt-2 w-full flex justify-center">
                            <Button className="bg-icon-color  text-sidebar-color drop-shadow-md   font-bold" type="submit">Submit</Button>
                            <Button className="ml-2" color="gray" onClick={() => {setEditModal(false);resetErrors();}}>
                                Cancel
                            </Button>
                        </div>
                        </form>
                    </div>
                </Modal.Body>
            </Modal>

            <Modal show={DeleteModal} size="md" onClose={() => setDeleteModal(false)} popup>
                <Modal.Header />
                <Modal.Body>
                    <div className="text-center">
                        <HiOutlineExclamationCircle className="mx-auto mb-4 h-14 w-14 text-gray-400 dark:text-gray-200" />
                        <h3 className="mb-5 text-lg font-normal text-gray-500 dark:text-gray-400">
                            Are you sure you want to delete this raw material?
                        </h3>
                        <div className="flex justify-center gap-4">
                            <Button color="failure" onClick={() => deletRawMaterial()}>
                                {"Yes"}
                            </Button>
                            <Button color="gray" onClick={() => setDeleteModal(false)}>
                                No
                            </Button>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>

        </div>


    );
}

export default RawMaterial;
